import * as t from "io-ts";
import { RevisionCommonDataV } from "@/types/revisions";
import { DynamicFieldOutputV } from "@/types/dynamic-data";

export const VariableTypeV = t.union([
  t.literal("text"),
  t.literal("number"),
  t.literal("unit"),
  t.literal("color"),
  t.literal("font_family"),
  t.literal("image_url")
]);

export type VariableType = t.TypeOf<typeof VariableTypeV>;

export const VariableV = t.intersection([
  t.type({
    id: t.string,
    type: VariableTypeV,
    cssVariableName: t.string,
    label: t.string,
    value: t.unknown,
    collection: t.string
  }),
  t.partial({
    fallback: t.unknown,
    override: t.boolean,
    dynamicData: DynamicFieldOutputV,
    local: t.boolean
  })
]);

export type Variable = t.TypeOf<typeof VariableV>;

export const VariableListV = t.array(VariableV);

// Revisions

export const VariablesRevisionV = t.intersection([
  RevisionCommonDataV,
  t.type({
    variables: VariableListV
  })
]);
export type VariablesRevision = t.TypeOf<typeof VariablesRevisionV>;

export const VariablesRevisionsListV = t.array(VariablesRevisionV);
export type VariablesRevisionsList = t.TypeOf<typeof VariablesRevisionsListV>;

// Load data

export const LoadedVariablesDataV = t.exact(
  t.type({
    template: t.string,
    variables: VariableListV,
    collections: t.array(t.string),
    propertyPathsToWhitelistInFlatProps: t.array(t.string)
  })
);

export type LoadedVariablesData = t.TypeOf<typeof LoadedVariablesDataV>;
